import type { Branded } from "@@/utilities/branded";
import { genericId } from "@@/utilities/generic-id";

type AddParakeyIntegrationCommandId = Branded<
    string,
    "AddParakeyIntegrationCommandId"
>;
const addParakeyIntegrationCommandIdPrefix = "add_integration__";
const {
    factory: addParakeyIntegrationCommandIdFactory,
    assert: isAddParakeyIntegrationCommandId,
    zodSchema: addParakeyIntegrationCommandIdZodSchema,
} = genericId<AddParakeyIntegrationCommandId>(
    addParakeyIntegrationCommandIdPrefix,
);

export {
    addParakeyIntegrationCommandIdFactory,
    addParakeyIntegrationCommandIdPrefix,
    addParakeyIntegrationCommandIdZodSchema,
    isAddParakeyIntegrationCommandId,
};
export type { AddParakeyIntegrationCommandId as AddParakeyIntegrationCommandId };
